class MainMenu {
  constructor() {
    this.body = document.querySelector("body")
    this.modals = document.querySelector(".modals")
    this.menu = document.querySelector(".modal__box--menu")
    this.menuContainer = document.querySelector(".menu-main-container")
    this.menuBottom = document.querySelector(".menu__bottom")
    this.openButton = document.querySelector(".header__nav__burger")
    this.closeButton = document.querySelector(".modal__close--menu")
    this.langSelector = document.querySelector(".lang-selector__default")
    this.langsList = document.querySelector(".lang-selector > nav")
    // this.modalBoxes = document.querySelectorAll(".modal__box")
    this.events()
  }
  events() {
    this.openButton.addEventListener("click", () => this.openMenu())
    this.menu.addEventListener("click", (e) => {
      e.stopPropagation()
    })
    this.langSelector.addEventListener("click", (e) => {
      e.stopPropagation()
    })
    this.modals.addEventListener("click", () => this.hideMenu())
    this.closeButton.addEventListener("click", () => this.hideMenu())
    this.langSelector.addEventListener("click", () => this.toggleLangs())
    this.menuContainer.addEventListener("click", () => this.hideLangs())
    this.menuBottom.addEventListener("click", () => this.hideLangs())
  }
  openMenu() {
    this.modals.classList.toggle("act")
    this.menu.classList.toggle("act")
    this.body.style.overflow = "hidden"
  }
  hideMenu() {
    if (this.modals.classList.contains("act")) {
      this.modals.classList.remove("act")
      this.menu.classList.remove("act")
      this.body.style.overflow = "auto"
      this.langSelector.classList.remove("act")
      this.langsList.classList.remove("act")
    }
    document.querySelector('.modal__box--article__iframe').setAttribute('src', '');
  }
  toggleLangs() {
    this.langSelector.classList.toggle("act")
    this.langsList.classList.toggle("act")
  }
  hideLangs() {
    this.langSelector.classList.remove("act")
    this.langsList.classList.remove("act")
  }
}
export default MainMenu
